const infoSections = [
  {
    title: "Project Milestones",
    content: (
      <>
        <h3>Fall 2022</h3>
        <table className="fall-2022">
          <thead>
            <tr>
              <td>Date</td>
              <td>Goal</td>
              <td>Hit</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>September 16th, 2022</td>
              <td>First Team Meeting</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>September 19th, 2022</td>
              <td>Website Initialization</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>September 29th, 2022</td>
              <td>First Client Meeting</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>October 7th, 2022</td>
              <td>
                Team Inventory Document
                <br />
                Team Standards Document
              </td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>November 11th, 2022</td>
              <td>Tech Feasibility Study</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>December 3rd, 2022</td>
              <td>Design Review Conference Presentation</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>December 9th, 2022</td>
              <td>
                Requirements Document Final Due
                <br />
                Tech Demo Completed with Mentor
              </td>
              <td>Yes</td>
            </tr>
          </tbody>
        </table>

        <h3>Spring 2023</h3>
        <table className="spring-2023">
          <thead>
            <tr>
              <td>Date</td>
              <td>Goal</td>
              <td>Hit</td>
            </tr>
          </thead>
          <tbody>
            {/* <tr>
              <td>January 27th, 2023</td>
              <td>Communication Memo</td>
              <td>Yes</td>
            </tr> */}
            <tr>
              <td>February 5th, 2023</td>
              <td>Frontend UI Research</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>February 12th, 2023</td>
              <td>Edit Single Keyframe</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>February 17th, 2023</td>
              <td>Software Design Document</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>February 19th, 2023</td>
              <td>Finish Frontend UI</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>March 3rd, 2023</td>
              <td>Timeline/Internal Structure</td>
              <td>Yes</td>
            </tr>
            {/* <tr>
              <td>March 5th, 2023</td>
              <td>UGRADS Registration</td>
              <td>Yes</td>
            </tr> */}
            <tr>
              <td>March 10th, 2023</td>
              <td>Mesh Storage Structure</td>
              <td>Yes</td>
            </tr>
            {/* <tr>
              <td>March 12th, 2023</td>
              <td>Design Review 2 Step 1</td>
              <td>Yes</td>
            </tr> */}
            <tr>
              <td>March 24th, 2023</td>
              <td>Prototype Demo</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>March 24th, 2023</td>
              <td>Design Review 2 Step 3</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>March 31st, 2023</td>
              <td>OBJ Sequence Exporting</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>April 7th, 2023</td>
              <td>Software Testing Plan</td>
              <td>Yes</td>
            </tr>
            {/* <tr>
              <td>April 14th, 2023</td>
              <td>Capstone Poster</td>
              <td>Yes</td>
            </tr> */}
            {/* <tr>
              <td>April 14th, 2023</td>
              <td>Capstone Presentation & Design Review Run</td>
              <td>Yes</td>
            </tr> */}
            <tr>
              <td>April 21st, 2023</td>
              <td>Design Review 2 Step 2</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>April 21st, 2023</td>
              <td>Completed Team Website</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>April 28th, 2023</td>
              <td>Design Review 3</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>May 5th, 2023</td>
              <td>Project Mini-Video (Final)</td>
              <td>No</td>
            </tr>
            <tr>
              <td>May 12th, 2023</td>
              <td>Final Demo</td>
              <td>No</td>
            </tr>
            <tr>
              <td>May 12th, 2023</td>
              <td>Final Written Report</td>
              <td>No</td>
            </tr>
            {/* <tr>
              <td>May 12th, 2023</td>
              <td>Team Reflection Document</td>
              <td>No</td>
            </tr> */}
            <tr>
              <td>May 12th, 2023</td>
              <td>User Manual & Checkoff Sheet</td>
              <td>No</td>
            </tr>
            <tr>
              <td>May 12th, 2023</td>
              <td>Handoff to Client</td>
              <td>No</td>
            </tr>
          </tbody>
        </table>
      </>
    ),
  },
  {
    title: "Requirements",
    content: (
      <ol>
        <li>
          The interface shall include an interactive timeline of model poses.
        </li>
        <li>The interface shall allow pinning of keyframes to a timeline.</li>
        <li>
          The plugin shall allow saving of multiple poses without interrupting
          the modeling workflow.
        </li>
        <li>
          The plugin shall allow export of an entire animation with multiple
          poses as an object sequence file.
        </li>
      </ol>
    ),
  },
  {
    title: "Technologies",
    content: (
      <ul>
        <li>
          <b>ZBrush</b>A digital sculpting tool that is used by artists to
          render 3D animated objects. This tool is used by our client and is the
          program that we were commissioned by our client to write a plugin for.
        </li>
        <li>
          <b>ZScript</b>A scripting language that is built into ZBrush. This is
          the language that we will use to create our plugin per our clients
          specifications.
        </li>
        <li>
          <b>React</b>Used to put together this website. We chose this as an
          alternative to plain HTML, CSS, and vanilla JavaScript for its
          advantage in maintainability.
        </li>
        <li>
          <b>GitHub</b>We chose to use Github to house our team website
          repository as well as our Zscript source code. All version control was
          done through git commits and pull requests on respective branches. We
          also took advantage of the ability to integrate Github into Jira for
          tracking our overall progress.
        </li>
        <li>
          <b>Jira</b>Jira is an issue and project tracking tool. We chose this
          tool because it implements agile methodologies and provides visibility
          of all project components to all team members. We will integrate
          Github into our Jira board to consolidate all project tracking into
          one place.
        </li>
        <li>
          <b>Discord</b>We chose Discord as our main platform for voice, video,
          and chat communications amongst our team members because it is a tool
          we have all used before and is a quick and easy way to get in contact
          with each other. We also used it to manage communications with our
          client and mentor as well.
        </li>
        <li>
          <b>Visual Studio Code</b>We chose to use Visual Studio code as our IDE
          because it supports extensions for developing in ZScript and running
          within ZBrush.
        </li>
      </ul>
    ),
  },
  {
    title: "Development Process",
    content: (
      <p>
        Our team held sprint planning meetings on Mondays, check-ins on
        Wednesdays as needed, and deployment on Fridays. We also checked in with
        our mentor once a week on Tuesdays (Fall) and Thursdays (Spring), and
        with our sponsor on Mondays. Our Code and UI Design Leads were
        responsible for breaking down tasks as needed and communicating with our
        Team Lead for task delegation.
      </p>
    ),
  },
  {
    title: "Envisioned Solution",
    content: (
      <p>
        Our Envisioned Solution was a ZBrush plugin integrated into the ZBrush
        software that will allow for the saving of multiple poses as keyframes.
        The solution reduces the disruption to workflow previously caused by the
        current single pose export system. It streamlines the saving of ZSphere
        rigs with an intuitive UI that is accessible to users unfamiliar with
        the ZBrush software. This is necessary to avoid learning the niche
        techniques currently required to create comparable pose by pose
        animation.
      </p>
    ),
  },
];

export default infoSections;
